import React, {useState, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import RowLayout from '../../../../../components/Layouts/RowLayout';
import SMCButton from '../../../../../components/Simple/SMCButton';
import SMCLabel from '../../../../../components/Simple/SMCLabel';
import {SMCCheckbox} from '../../../../../components/Simple/SMCCheckbox';
import SMCTextInput from '../../../../../components/Simple/SMCTextInput';

function CustomFieldsTable({
    customFieldsList,
    setCustomFieldsList
}) {
    const { t } = useTranslation();
    const [selected, setSelected] = useState([]);

    const newOnClick = useCallback(() => {
        if (!customFieldsList || customFieldsList.length === 0) {
            setCustomFieldsList(['']);
        } else if (customFieldsList.length === 1) {
            setCustomFieldsList([...customFieldsList, '']);
        }
    }, [customFieldsList, setCustomFieldsList]);

    const deleteOnClick = useCallback(() => {
        if (customFieldsList && selected.length) {
            setCustomFieldsList(customFieldsList.filter((obj, i) => selected.indexOf(i) === -1));
            setSelected([]);
        }
    }, [customFieldsList, selected, setCustomFieldsList]);


    return (
        <>
        <RowLayout>
            <SMCButton
                icon="new"
                variant="ghost"
                onClick={newOnClick}
                disabled={customFieldsList && customFieldsList.length >= 2}
            >
                {t('SMC_GEN_NEW')}
            </SMCButton>
            <SMCButton
                icon="delete"
                variant="ghost"
                onClick={deleteOnClick}
                disabled={!customFieldsList || !customFieldsList.length || !selected.length}
            >
                {t('SMC_GEN_DELETE')}
            </SMCButton>
        </RowLayout>
        {
            customFieldsList && (
                customFieldsList.map((customField, index) => (
                    <RowLayout key={index} spacing={'5px'}>
                        <SMCLabel bold inline>{index+1}</SMCLabel>
                        <SMCCheckbox
                            checked={selected.includes(index)}
                            onChange={e => {
                                if (e.target.checked) {
                                    setSelected(selected => [...selected, index]);
                                } else {
                                    setSelected(selected => selected.filter(i => i !== index));
                                }
                            }}
                        />
                        <SMCTextInput
                            value={customField}
                            onChange={e => {
                                const updatedUserCustomFields = [...customFieldsList];
                                updatedUserCustomFields[index] = e.target.value;
                                setCustomFieldsList(updatedUserCustomFields);
                            }}
                        />
                    </RowLayout>
                ))
            )
        }
        </>
    );
}

export default CustomFieldsTable;